import _typeof from "@babel/runtime/helpers/typeof";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _assign from "lodash/assign";
import * as EasyAsync from 'redux-easy-async';
import { JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE } from "../constants";
export var createAsyncAction = function createAsyncAction(actionName, fn, options) {
  return EasyAsync.createAsyncAction(actionName, fn, _objectSpread({
    namespace: JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE
  }, options));
};
var OPTIMISTIC_NAMESPACE = 'OPTIMISTIC_NAMESPACE';

var createOptimisticConstants = function createOptimisticConstants(type) {
  return {
    getType: function getType() {
      return "OPTIMISTIC_".concat(type);
    },
    ROLLBACK_TYPE: "ROLLBACK_".concat(type),
    COMMIT_TYPE: "COMMIT_".concat(type),
    NAMESPACE: OPTIMISTIC_NAMESPACE
  };
};

var OPTIMISTIC_ERRORS = {
  ACTION_NOT_OBJECT: 'createOptimisticAction(type, fn): fn must return an object',
  DO_WORK_NOT_FUNCTION: 'createOptimisticAction(type, fn, doWork): call must have a doWork function'
};
export var decorateOptimisticAction = function decorateOptimisticAction(action, optimisticConstants, doWork) {
  _assign(action, _objectSpread(_objectSpread({}, optimisticConstants), {}, {
    doWork: doWork
  }));
};
export var createOptimisticAction = function createOptimisticAction(type, fn, doWork) {
  if (typeof doWork !== 'function') {
    throw new Error(OPTIMISTIC_ERRORS.DO_WORK_NOT_FUNCTION);
  }

  var optimisticConstants = createOptimisticConstants(type);

  var actionCreator = function actionCreator() {
    var optimisticAction = fn.apply(void 0, arguments);

    if (_typeof(optimisticAction) !== 'object') {
      throw new Error(OPTIMISTIC_ERRORS.ACTION_NOT_OBJECT);
    }

    var _optimisticAction$pay = optimisticAction.payload,
        payload = _optimisticAction$pay === void 0 ? {} : _optimisticAction$pay,
        _optimisticAction$rol = optimisticAction.rollback,
        rollback = _optimisticAction$rol === void 0 ? {} : _optimisticAction$rol,
        _optimisticAction$com = optimisticAction.commit,
        commit = _optimisticAction$com === void 0 ? {} : _optimisticAction$com,
        _optimisticAction$eff = optimisticAction.effect,
        effect = _optimisticAction$eff === void 0 ? {} : _optimisticAction$eff;
    return {
      type: optimisticConstants.getType(),
      payload: payload,
      meta: {
        offline: {
          effect: effect,
          rollback: {
            type: optimisticConstants.ROLLBACK_TYPE,
            meta: rollback
          },
          commit: {
            type: optimisticConstants.COMMIT_TYPE,
            meta: commit
          }
        }
      }
    };
  };

  decorateOptimisticAction(actionCreator, optimisticConstants, doWork);
  return actionCreator;
};
export var isOptimisticAction = function isOptimisticAction(action) {
  return action && action.NAMESPACE === OPTIMISTIC_NAMESPACE && action.COMMIT_TYPE && action.ROLLBACK_TYPE;
};
/**
 * Parses a GraphQL error for important fields.
 *
 * @param {*} error GraphQLError
 */

export var parseGraphQLErrorDetails = function parseGraphQLErrorDetails() {
  var _response$body, _response$body$error;

  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extensions = error.extensions,
      errorMessage = error.message;
  var response = extensions === null || extensions === void 0 ? void 0 : extensions.response;
  var responseData = response === null || response === void 0 ? void 0 : (_response$body = response.body) === null || _response$body === void 0 ? void 0 : (_response$body$error = _response$body.error) === null || _response$body$error === void 0 ? void 0 : _response$body$error.data;
  var msg = (responseData === null || responseData === void 0 ? void 0 : responseData.internal_message) || errorMessage;
  return {
    code: extensions === null || extensions === void 0 ? void 0 : extensions.code,
    errorType: extensions === null || extensions === void 0 ? void 0 : extensions.code,
    // query0 requests go through as a POST
    httpMethod: 'POST',
    httpStatusCode: response === null || response === void 0 ? void 0 : response.status,
    internalMessage: msg,
    responseData: responseData,
    systemErrorCode: response === null || response === void 0 ? void 0 : response.statusText,
    systemErrorMessage: msg,
    url: response === null || response === void 0 ? void 0 : response.url,
    userMessage: responseData === null || responseData === void 0 ? void 0 : responseData.user_message
  };
};
/**
 * Extracts the Anti Fraud Error's decision out of the GraphQL error response, if available
 * @param response
 * @returns {string} The anti-fraud decision
 */

export var getAntiFraudDecision = function getAntiFraudDecision(response) {
  var _response$graphQLErro;

  var graphQLError = response === null || response === void 0 ? void 0 : (_response$graphQLErro = response.graphQLErrors) === null || _response$graphQLErro === void 0 ? void 0 : _response$graphQLErro[0];

  if (!graphQLError) {
    return null;
  }

  var _parseGraphQLErrorDet = parseGraphQLErrorDetails(graphQLError),
      code = _parseGraphQLErrorDet.code,
      responseData = _parseGraphQLErrorDet.responseData;

  return code === 'ANTI_FRAUD_ERROR' ? responseData === null || responseData === void 0 ? void 0 : responseData.decision : null;
};